module.exports = __webpack_public_path__ + "img/proud.36b1f520.png";